import React from 'react';
import FinancialsWidgetRenderer from './FinancialsWidgetRenderer';

const Preview: React.FC = () => (
  <FinancialsWidgetRenderer config={{}} />
);

export default Preview;
